export default __webpack_public_path__ + "static/media/primary.76a080e4.svg";